import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantRegistrationTypeService } from '../../services/wealthlane-customer-services';

const useGetParticipantRegistrationType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const ParticipantRegistrationTypeList = useQuery(
    ['getParticipantRegistrationTypeList'],
    async () => {
      return await handleRequest(
        ParticipantRegistrationTypeService.getApiCustomerApiAppParticipantRegistrationTypeParticipantRegistrationTypesList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return ParticipantRegistrationTypeList;
};

export default useGetParticipantRegistrationType;
